import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { JobListingItem } from '../../jobs-module/models/listing.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EditorText } from '../../shared-module/components/mj-text-editor/mj-text-editor.component';

@Component({
  selector: 'mj-job-video',
  templateUrl: './job-video.component.html',
  styleUrls: ['./job-video.component.scss'],
})
export class JobVideoComponent implements OnInit, OnChanges {
  @Input() listingItem: JobListingItem;

  isColorPickerOn;

  @Output() onItemChanged = new EventEmitter<JobListingItem>();
  @Output() public onItemScheduledForRemoval = new EventEmitter();

  iframeUrl: any;
  autoplayInitValue: boolean;
  videoErr: boolean;
  form: FormGroup;

  constructor(private fb: FormBuilder, private sanitizer: DomSanitizer) {
    this.form = this.fb.group({
      title: '',
      title_rich: '',
      vimeo_video_id: '',
      youtube_video_id: '',
      autoplay: true,
    });
  }

  ngOnInit() {
    this.setVideoUrl();
    this.autoplayInitValue = this.listingItem.autoplay;
  }

  onVideoIdAdd(url: string) {
    url.match(
      /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
    );
    let type = '';
    if (RegExp.$3.indexOf('youtu') > -1) {
      type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
      type = 'vimeo';
    }

    if (type === 'youtube') {
      this.form.patchValue({
        vimeo_video_id: null,
        youtube_video_id: RegExp.$6,
      });
      this._updateValues();
    }

    if (type === 'vimeo') {
      this.form.patchValue({
        vimeo_video_id: RegExp.$6,
        youtube_video_id: null,
      });
      this._updateValues();
    }

    this.videoErr = !type;

    this.setVideoUrl();
  }

  onKeyUp(event) {
    if (event && event.key === 'Enter') {
      if (event.target && event.target.value) {
        this.onVideoIdAdd(event.target.value);
      }
    }
  }

  setVideoUrl() {
    if (
      this.form.value.youtube_video_id &&
      this.form.value.youtube_video_id.length
    ) {
      this.iframeUrl = this.cleanURL(
        `https://www.youtube.com/embed/${this.form.value.youtube_video_id}`
      );
    }
    if (
      this.form.value.vimeo_video_id &&
      this.form.value.vimeo_video_id.length
    ) {
      this.iframeUrl = this.cleanURL(
        `https://player.vimeo.com/video/${this.form.value.vimeo_video_id}`
      );
    }
  }

  cleanURL(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  setAutoplay(event) {
    this.form.patchValue({
      autoplay: event.checked,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title !== this.listingItem.title
    ) {
      this.form.patchValue({
        title: this.listingItem.title,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title_rich !== this.listingItem.title_rich
    ) {
      this.form.patchValue({
        title_rich: this.listingItem.title_rich,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.autoplay !== this.listingItem.autoplay
    ) {
      this.form.patchValue({
        autoplay: this.listingItem.autoplay,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.vimeo_video_id !== this.listingItem.vimeo_video_id
    ) {
      this.form.patchValue({
        vimeo_video_id: this.listingItem.vimeo_video_id,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.youtube_video_id !== this.listingItem.youtube_video_id
    ) {
      this.form.patchValue({
        youtube_video_id: this.listingItem.youtube_video_id,
      });
    }
  }

  saveTitle($event: EditorText) {
    this.form.patchValue({
      title_rich: $event.rich,
      title: $event.plain,
    });
    this._updateValues();
  }

  _updateValues() {
    this.onItemChanged.emit({ ...this.listingItem, ...this.form.value });
  }
}
